import React from 'react';
import Icon from '../../components/AppIcon';
import ArabicDateTime from '../../components/ui/ArabicDateTime';

/**
 * Displays a timeline of previous admin review notes (revision requests / rejections).
 * Used in the admin dashboard decision panel when viewing an article.
 */
const ReviewNotesHistory = ({ items = [] }) => {
  if (!items?.length) return null;

  return (
    <div className="mb-6">
      <h3
        className="text-sm font-medium text-foreground mb-3 flex items-center gap-2"
        style={{ fontFamily: 'Amiri, serif', fontWeight: 700 }}
      >
        <Icon name="ScrollText" size={16} color="var(--color-muted-foreground)" />
        سجل الملاحظات السابقة
      </h3>

      <div className="relative pr-4 border-r-2 border-[var(--color-border)]">
        {items.map((item, index) => (
          <div
            key={index}
            className="relative pb-4 last:pb-0 group"
          >
            {/* Timeline dot - aligned with first row (طلب تعديل) */}
            <div
              className="absolute top-5 right-0 w-3 h-3 rounded-full border-2 border-[var(--color-background)] flex-shrink-0 z-10 -translate-x-1/2"
              style={{
                backgroundColor: item.action === 'reject' ? 'var(--color-error)' : 'var(--color-warning)',
                boxShadow: '0 0 0 2px var(--color-border)'
              }}
            />

            <div
              className="rounded-lg p-3 bg-muted/50 hover:bg-muted/70 transition-colors border border-border/50"
              style={{ fontFamily: 'Amiri, serif' }}
            >
              <div className="flex flex-wrap items-center gap-2 mb-2">
                <span
                  className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                    item.action === 'reject'
                      ? 'bg-error/15 text-error'
                      : 'bg-warning/15 text-warning'
                  }`}
                >
                  {item.action === 'reject' ? 'رفض' : 'طلب تعديل'}
                </span>
                {item.reviewerName && (
                  <span className="text-xs text-muted-foreground">
                    {item.reviewerName}
                  </span>
                )}
                <ArabicDateTime
                  date={new Date(item.createdAt)}
                  format="full"
                  className="text-xs text-muted-foreground mr-auto"
                />
              </div>
              <p className="text-sm text-foreground leading-relaxed whitespace-pre-wrap">
                {item.note}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewNotesHistory;
